exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contenedor-fijo__div-container-desktop{max-width:945px;width:100%}@media(max-width:799px){.contenedor-fijo__div-padding-mobile{padding-left:15px;padding-right:15px}}@media(min-width:800px){.contenedor-fijo__container-zp{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.contenedor-fijo__div-padding-desktop{padding-left:15px;padding-right:15px}}@media (min-width:768px){.container{max-width:945px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":false}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null]}!./src/css/components/ContenedorFijo.css
// module id = 434
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13